import { faDesktop, faLocationDot } from '@fortawesome/pro-light-svg-icons';
import { Professional, ProfessionalSchedule } from '@medprev-web-app/api-graphql-client';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Icon } from '@/components/ui/icon.component';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';
import { transformInPersonSchedules } from '@/utils/professional/extract-professional-location';

interface ProfessionalServiceLocationsProps {
  professional: Professional;
  telehealthData: ProfessionalSchedule[];
  inPersonData: ProfessionalSchedule[];
  dataTestId?: string;
}

export function ProfessionalServiceLocations({
  inPersonData,
  telehealthData: telehealthSchedules,
  dataTestId,
}: ProfessionalServiceLocationsProps) {
  const inPersonLocations = transformInPersonSchedules(inPersonData);

  const totalInPersonLocations = Object.values(inPersonLocations).reduce((acc, locArray) => acc + locArray.length, 0);

  const entityTile
    = totalInPersonLocations > 1 || (telehealthSchedules.length && totalInPersonLocations > 0)
      ? 'Locais de atendimento'
      : 'Local de atendimento';

  return (
    <div data-testid={dataTestId}>
      <h2 className="text-gray-800 text-xl font-semibold">{entityTile}</h2>
      {!!telehealthSchedules.length && (
        <div className="flex gap-3 mt-5" data-testid={DataTestIdEnum.PROFESSIONAL_SERVICE_LOCATIONS_TELEHEALTH_SECTION}>
          <div className="bg-blue-100 w-6 h-6 text-blue-600 rounded-sm  flex items-center justify-center">
            <Icon icon={faDesktop} className="text-sm w-[1.125rem] h-[1.125rem]" />
          </div>
          <div className="flex flex-col">
            <span className="text-blue-600 font-semibold text-base">Teleconsulta</span>
            <span className="text-gray-500 text-sm mt-1">Atendimento por chamada de vídeo</span>
          </div>
        </div>
      )}
      {totalInPersonLocations > 0 && (
        <div className="mt-5" data-testid={DataTestIdEnum.PROFESSIONAL_SERVICE_LOCATIONS_IN_PERSON_SECTION}>
          {Object.entries(inPersonLocations).map(([key, value]) => (
            <div key={key} className="mt-3" data-testid={`in-person-location-${key}`}>
              <div className="flex gap-3">
                <div className="bg-blue-100 w-6 h-6 text-blue-600 rounded-sm  flex items-center justify-center">
                  <Icon icon={faLocationDot} className="text-sm w-[1.125rem] h-[1.125rem]" />
                </div>
                <div>
                  <span className="text-blue-600 font-semibold text-base">{key}</span>
                  {value.map((address) => (
                    <div key={address.socialName} className="flex gap-3 mt-1">
                      <span className="text-gray-500 font-normal text-sm">
                        {formatToTitleCase(address.socialName)}
                        {' '}
                        •
                        {' '}
                        {formatToTitleCase(address.neighborhood)}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <hr className="mt-7" />
    </div>
  );
}
